import React from 'react';
import { useHistory } from 'react-router';

// Type
import { GoalItem } from 'Shared/constants/types';

// Constants
import PageUrlsConstants from 'Shared/constants/PageUrls.constants';

// Hooks
import { useGoal } from 'Shared/utils/hooks/use-goal';

// Components
import ConfirmModal from 'Shared/components/ConfirmModal/ConfirmModal';
import { WpAlert } from 'Wpds/components/alert';

type Props = {
  goal: GoalItem;
  isOpen: boolean;
  toggleIsOpen: () => void;
  onDeleteSuccess?: Function;
};

const GoalDeleteConfirmationModal = ({ goal, isOpen, toggleIsOpen, onDeleteSuccess }: Props) => {
  const history = useHistory();
  const { isSaving, handleDeleteGoal, subGoals, parentGoal } = useGoal({ slug: goal.slug });

  const hasSubGoals = subGoals.length > 0;
  const totalActionItems = goal.numCompleteActionItems + goal.numIncompleteActionItems;
  const hasActionItems = totalActionItems > 0;

  const handleConfirmClick = () => {
    handleDeleteGoal().then(() => {
      if (onDeleteSuccess) onDeleteSuccess();
      else history.push(PageUrlsConstants.GOALS_PAGE);
      toggleIsOpen();
    });
  };

  return (
    <ConfirmModal
      message="Are you sure you want to delete this goal?"
      isOpen={isOpen}
      isProcessing={isSaving}
      onToggle={toggleIsOpen}
      onConfirmClick={handleConfirmClick}
      confirmButtonLabel="Delete"
    >
      <p>Are you sure you want to delete this goal?</p>
      {(hasSubGoals || hasActionItems) && (
        <WpAlert showIcon={false} type="note">
          <p style={{ fontWeight: 'bold' }}>A quick note...</p>
          <ul>
            {hasSubGoals && parentGoal && (
              <li>
                Deleting this goal will not remove its {subGoals.length} sub-goal{subGoals.length > 1 ? 's' : ''}; they
                will be added to the parent goal ({parentGoal.name}).
              </li>
            )}
            {hasSubGoals && !parentGoal && (
              <li>
                Deleting this goal will not remove its {subGoals.length} sub-goal{subGoals.length > 1 ? 's' : ''}; they
                will now stand on their own as independent goals.
              </li>
            )}
            {hasActionItems && (
              <li>
                This goas has {totalActionItems} action item{totalActionItems > 0 ? 's' : ''} which will be deleted.
              </li>
            )}
          </ul>
        </WpAlert>
      )}
    </ConfirmModal>
  );
};

export default GoalDeleteConfirmationModal;
